const getters = {
  token: state => state.globalVar,
  rateVar: state => state.globalVar.rateVar,
  fetusTurnRecordId: state => state.globalVar.fetusTurnRecordId,
  startAt: state => state.globalVar.startAt,
  isLoading: state => state.globalVar.isLoading,
  hasLoginCache: state => state.globalVar.hasLoginCache,
}
export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js